import React from 'react'
import classNames from 'classnames'
import {Button} from '@/components'
import { useTranslation } from 'react-i18next'
import {CookiesAcceptProps} from './props'
import styles from './styles.scss'
import {
    ACCEPT_ALL_COOKIES,
    ACCEPT_ESSENTIAL_COOKIES,
    ACCEPT_INDIVIDUAL_COOKIES
} from '@/constants/playwright-ids'

export const CookiesAccept: React.FC<CookiesAcceptProps> = ({
    className,
    onAllClick,
    onIndividualClick,
    onEssentialClick
}) => {
    const { t } = useTranslation()
    return (
        <div className={classNames(styles.links, className)}>
            <Button
                type={'primary'}
                onClick={onAllClick}
                className={styles.acceptAll}
                data-test-id={ACCEPT_ALL_COOKIES}
            >
                {t('CookiesAccept.acceptAll')}
            </Button>
            <a data-test-id={ACCEPT_ESSENTIAL_COOKIES} href={'#'} onClick={onEssentialClick}>
                {t('CookiesAccept.acceptOnlyEssential')}
            </a>
            <a data-test-id={ACCEPT_INDIVIDUAL_COOKIES} href={'#'} onClick={onIndividualClick}>
                {t('CookiesAccept.initialPrivacy')}
            </a>
        </div>
    )
}
